angular.module("app.constants", [])
.constant("environment", {"name":"Production","host":"https://ecourses.bethel.tv","domain":"bethel.tv","googleAnalytics":"UA-2614909-29","sentry":{"url":"https://08d8865ec1564921ae79fcca1ec48847@sentry.bethel.tv/3"},"social":{"facebook":{"appId":"1502690709959100","pixels":{"conversion":"6033065760408","visitor":"902886969841346"}}},"site":{"parent":"http://marketplace.bethel.tv/","new":"http://marketplace.bethel.tv/"},"api":{"baseUrl":"https://marketplace.bethel.tv/api/v2"},"player":{"url":"http://marketplace.bethel.tv/player","previewToken":"7RoI7rcgng4C3ntWGP18CUngcWZ5z46d","liveguid":"pwezI6vMY52l7K1lhLAtfbmed14_h09V"}})
.constant("release", "88c71b5");



/** WEBPACK FOOTER **
 ** ./src/app/app.constants.js
 **/